import CommunicationStatusContainer from './CommunicationStatusContainer';

export default CommunicationStatusContainer;